// src/components/MFA/MFAProposalModal.tsx
import { FC, useState } from 'react';
import Button, { Button_Style, Button_Type } from 'shared/ui/Button/Button';
import './MFAProposalModal.scss';

interface MFAProposalModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
}

const MFAProposalModal: FC<MFAProposalModalProps> = ({ isOpen, onClose, onAccept }) => {
  const [isDeclining, setIsDeclining] = useState(false);

  if (!isOpen) return null;

  const handleAccept = () => {
    onAccept();
    onClose();
  };

  const handleDecline = () => {
    setIsDeclining(true);
    setTimeout(() => {
      onClose();
      setIsDeclining(false);
    }, 300);
  };

  return (
    <div className="mfa-proposal-overlay">
      <div className="mfa-proposal-modal">
        <button className="close-button" onClick={handleDecline}>×</button>

        <h2>Double authentification</h2>

        <p className="modal-description">
          Activez la double authentification pour renforcer la sécurité de votre compte
          et protéger vos données contre les accès non autorisés.
        </p>

        <div className="benefits">
          <div className="benefit-item">
            <div className="benefit-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <span>Sécurité renforcée</span>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" stroke="currentColor" strokeWidth="2" fill="none"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4" stroke="currentColor" strokeWidth="2" fill="none"/>
              </svg>
            </div>
            <span>Protection même si mot de passe volé</span>
          </div>
          <div className="benefit-item">
            <div className="benefit-icon">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" fill="none"/>
              </svg>
            </div>
            <span>Conformité aux standards de sécurité</span>
          </div>
        </div>

        <div className="modal-actions">
          <Button
            type={Button_Type.SECONDARY}
            style={Button_Style.OUTLINED}
            label={isDeclining ? 'Fermeture...' : 'Plus tard'}
            onClick={handleDecline}
          />
          <Button
            type={Button_Type.PRIMARY}
            style={Button_Style.SOLID}
            label="Activer maintenant"
            onClick={handleAccept}
          />
        </div>
      </div>
    </div>
  );
};

export default MFAProposalModal;